import Image, { StaticImageData } from 'next/image';
import { selling, training, register, account } from '@prishapolicy/w3/assets';
import { Button } from '@prishapolicy/shared/ui';
export const RoadMaps = () => {
  return (
    <div className="container flex flex-col gap-10 bg-white py-[60px]">
      <div className="flex flex-col gap-3">
        <div className="flex justify-center">
          <div className="bg-primary h-[5px] w-[50px] rounded-lg"></div>
        </div>
        <h1 className=" text-title-7 md:text-title-6 lg:text-title-6  text-primary text-center font-medium">
          Your Journey to POSP at PrishaPolicy
        </h1>
        <h1 className="text-title-4 text-center font-bold md:text-[40px] lg:text-[40px] ">
          Be the part of the best team in town
        </h1>
      </div>
      <div className="grid grid-cols-1 gap-10 md:grid-cols-2 xl:grid-cols-4">
        {[
          [account, 'Account Creation', 'Create your account to get started'],
          [register, 'Register yourself', 'Submit your KYC documents'],
          [training, 'Complete Training', 'Complete the training, give exam and get certified'],
          [selling, 'Start Selling', 'You are ready to sell insurance'],
        ].map((item, idx) => {
          return (
            <RoadMapImageCard
              image={item[0] as StaticImageData}
              title={item[1] as string}
              desc={item[2] as string}
              key={idx}
            />
          );
        })}
      </div>
      <div className="flex justify-center">
        <Button text="Start your POSP journey" rightIcon="arrowRight" href="#become-a-posp" />
      </div>
    </div>
  );
};

export interface RoadMapImageCardProps {
  image: StaticImageData;
  title: string;
  desc: string;
}

export const RoadMapImageCard = ({ image, title, desc }: RoadMapImageCardProps) => {
  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-center">
        <Image src={image} alt="" width={212} height={200} />
      </div>
      <div>
        <h1 className="text-title-5 md:text-title-4 lg:text-title-4 text-center font-bold leading-[42px]">{title}</h1>
        <p className="text-title-7 md:text-title-6 lg:text-title-6 text-center font-normal leading-[30px]">{desc}</p>
      </div>
    </div>
  );
};
